import Panel from "components/layout/panel";
import View from "components/layout/view";
import Title from "components/title";
import UserNavigation from "components/user-navigation/user-navigation";
import { useList } from "stores/hooks/list";
import { useListEntities } from "stores/hooks/list-entities";
import { useLocale } from "stores/hooks/locale";
import { parse } from "lib/locale";
import { Fragment, FunctionComponent } from "react";
import { useNavigate } from "react-router";
import ListSummaryForm from "./form";
import {
  userDoPostUserStatusProgress,
  userDoPostUserStatusSubmitted,
} from "services/user/status";
import SingleSummary from "./single";
import MultiSummary from "./multi";
import Line from "components/layout/line";
import { useAuthListUser } from "stores/hooks/auth";
import UserStatus from "components/user-navigation/user-status";
import { fetchAuthUser } from "stores/actions/auth";

interface UserListSummaryViewProps {}

const UserListSummaryView: FunctionComponent<UserListSummaryViewProps> = () => {
  const list = useList();
  const locale = useLocale();
  const entities = useListEntities();
  const navigate = useNavigate();
  const listUser = useAuthListUser();

  if (!list || !listUser) {
    return null;
  }

  const onFirst = async () => {
    await userDoPostUserStatusProgress();
    await fetchAuthUser();
    const firstEntity = entities[0];
    navigate(`/user/list/${list.uuid}/entity/${firstEntity.uuid}`);
  };

  const onPrevious = async () => {
    await userDoPostUserStatusProgress();
    await fetchAuthUser();
    const lastEntity = entities[entities.length - 1];
    navigate(`/user/list/${list.uuid}/entity/${lastEntity.uuid}`);
  };

  const onSubmit = async () => {
    await userDoPostUserStatusSubmitted();
    navigate(`/user/finished`);
  };

  const title = ["Yhteenveto", parse(list.name, locale)].join(" | ");
  return (
    <View title={title} navigation={false}>
      <UserNavigation />
      <Panel>
        <Title>Yhteenveto</Title>
        {entities.map((entity, index) => {
          const { uuid, multi } = entity;
          return (
            <Fragment key={uuid}>
              {multi === true && (
                <MultiSummary listUuid={list.uuid} listEntity={entity} />
              )}
              {multi === false && (
                <SingleSummary listUuid={list.uuid} listEntity={entity} />
              )}
              {index < entities.length - 1 && <Line />}
            </Fragment>
          );
        })}
        <ListSummaryForm
          listUser={listUser}
          onSubmit={onSubmit}
          onFirst={onFirst}
          onPrevious={onPrevious}
        />
        <UserStatus />
      </Panel>
    </View>
  );
};

export default UserListSummaryView;
